import React, { useState, useEffect } from 'react';
import InvocationsBarChart from '../components/charts/InvocationsBarChart';
import DurationLineChart from '../components/charts/DurationLineChart';
import ErrorCountLineChart from '../components/charts/ErrorCountLineChart';
import { useApi } from '../services/ApiService';

const PipelineDashboard = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [environment] = useState('production'); // default to staging
    const { apiRequest } = useApi();

    const fetchData = async (env) => {
        setLoading(true);
        setError(null);
        const result = await apiRequest('/daily-stats/', env, { method: 'GET' });
        if (result.data) {
            setData(result.data);
        }
        if (result.error) {
            setError(result.error);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData(environment);
    }, []); // Load data on mount

    if (loading) return <div>Loading data...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!data) return <div>No data available.</div>;

    // Card style: you can replace this with your UI library or Tailwind classes if available
    const cardStyle = {
        background: '#fff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        marginBottom: '20px',
    };


    return (
        <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>

            {/* Charts */}
            <div style={cardStyle}>
                <InvocationsBarChart data={data} />
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ ...cardStyle, flex: 1, marginRight: '10px' }}>
                    <DurationLineChart data={data} />
                </div>
                <div style={{ ...cardStyle, flex: 1, marginLeft: '10px' }}>
                    <ErrorCountLineChart data={data} />
                </div>
            </div>
        </div>
    );
};

export default PipelineDashboard;
